import React from "react";

const AddPlayerIconWithNumber = (props: any) => {
  return (
    <svg
      width="36"
      height="28"
      viewBox="0 0 36 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.05617 13H3.20941V7.94383C3.20941 7.80438 3.21141 7.63305 3.21539 7.42984C3.21937 7.22266 3.22535 7.01148 3.23332 6.79633C3.24129 6.57719 3.24926 6.37996 3.25723 6.20465C3.2134 6.25645 3.12375 6.34609 2.98828 6.47359C2.8568 6.59711 2.73328 6.70867 2.61773 6.80828L1.61367 7.61512L0.723164 6.50348L3.53812 4.26227H5.05617V13Z"
        fill="currentColor"
      />
      <g clip-path="url(#clip0_24961_225678)">
        <path
          d="M22.5832 11.9642C23.8761 11.9642 24.9242 10.7664 24.9242 9.28874C24.9242 7.81113 23.8761 6.61328 22.5832 6.61328C21.2903 6.61328 20.2422 7.81113 20.2422 9.28874C20.2422 10.7664 21.2903 11.9642 22.5832 11.9642Z"
          stroke="currentColor"
          stroke-width="1.13719"
          stroke-miterlimit="10"
        />
        <path
          d="M19.0063 19.1318H18.0176V16.0637C18.0176 14.3334 19.4135 12.9375 21.1438 12.9375"
          stroke="currentColor"
          stroke-width="1.13719"
          stroke-miterlimit="10"
        />
        <path
          d="M23.7321 12.9375C25.4624 12.9375 26.8583 14.3334 26.8583 16.0637V19.1318H20.6641"
          stroke="currentColor"
          stroke-width="1.13719"
          stroke-miterlimit="10"
        />
        <path
          d="M32.4998 13.4596C32.4998 18.9414 28.065 23.3763 22.5832 23.3763C17.1014 23.3763 12.6665 18.9414 12.6665 13.4596C12.6665 7.97784 17.1014 3.54297 22.5832 3.54297"
          stroke="currentColor"
          stroke-width="1.13719"
          stroke-miterlimit="10"
        />
        <path
          d="M29.3882 3.5V9.72336"
          stroke="currentColor"
          stroke-width="1.13719"
          stroke-miterlimit="10"
        />
        <path
          d="M32.4998 6.61328H26.291"
          stroke="currentColor"
          stroke-width="1.13719"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_24961_225678">
          <rect width="28" height="28" fill="white" transform="translate(8)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AddPlayerIconWithNumber;
